import { BASE_API_URL } from '@env';
import { useMutation } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import axios from 'axios';

interface CreateTransferPaymentIntentRequest {
  source_event_id: string;
  target_event_id: string;
  user_id: string;
  email: string;
  specific_guest_uids?: string[];
}

interface CreateTransferPaymentIntentResponse {
  client_secret: string;
  payment_intent_id: string;
  price_difference: {
    amount: number;
    currency: string;
    per_user: boolean;
  };
  status: string;
}

export const useCreateTransferPaymentIntent = () => {
  return useMutation<CreateTransferPaymentIntentResponse, Error, { eventId: string; transferData: CreateTransferPaymentIntentRequest }>(
    async ({ eventId, transferData }) => {
      const token = useUserStore.getState().token;
      
      if (!token) {
        throw new Error('No authentication token available');
      }

      console.log('🔍 useCreateTransferPaymentIntent: Making API call with token:', token ? 'EXISTS' : 'MISSING');
      console.log('🔍 useCreateTransferPaymentIntent: API URL:', `${BASE_API_URL}events/${eventId}/transfer/create-payment-intent`);
      console.log('🔍 useCreateTransferPaymentIntent: Transfer data:', transferData);

      const config = {
        headers: { 
          Authorization: token, 
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      };

      try {
        const response = await axios.post(`${BASE_API_URL}events/${eventId}/transfer/create-payment-intent`, transferData, config);
        console.log('🔍 useCreateTransferPaymentIntent: API Response:', response.data);
        return response.data;
      } catch (error) {
        console.error('🔍 useCreateTransferPaymentIntent: API Error:', error);
        if (axios.isAxiosError(error)) {
          const errorMessage = error.response?.data?.message || error.message;
          throw new Error(`Failed to create transfer payment intent: ${error.response?.status} - ${errorMessage}`);
        }
        throw new Error('Failed to create transfer payment intent');
      }
    }
  );
};